/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Navbar from 'modules/common/components/navbar';
import NFTCard from 'modules/common/components/card';
import { useSelector } from 'react-redux';
import { getNFTsList } from 'modules/home/selectors';
import Pagination from 'modules/common/components/pagination';

const Artworks = () => {
  const postsList = useSelector(getNFTsList);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = postsList.slice(firstPostIndex, lastPostIndex);
  return (
    <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover min-h-screen h-fit">
      <Navbar />
      <div className='xl:mt-20 2xl:mt-28 w-full container mx-8 lg:mx-auto px-24'>
        <div>
          <div className='flex justify-between mt-20'>
            <h1 className="text-2xl lg:text-5xl font-['Poppins'] font-semibold text-white">
              Latest Artworks
            </h1>
            <div>.</div>
          </div>
          <div className='flex justify-center mt-12'>
            <div className='lg:grid xl:grid-cols-3 2xl:grid-cols-4 gap-16'>
              {currentPosts.map((post) => (
                <div>
                  <NFTCard
                    key={post.token_id}
                    token_id={post.token_id}
                    image={post.image}
                    title={post.name}
                    price={post.price}
                    seller={post.seller}
                    owner={post.currentOwner}
                  />
                </div>
              ))}
            </div>
          </div>
          {currentPosts.length === 0 && (
            <div className='w-full flex justify-center text-white'>
              No data...
            </div>
          )}
          <Pagination
            totalPosts={postsList.length}
            postsPerPage={postsPerPage}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Artworks;
